import React from 'react';
import { useLocale } from '../../hooks/useLocale';
import { useStoreActions, useStoreState } from '../../store';
import { SubtitleTextSizes } from '../../typings';
import { MenuHeader } from './MenuHeader';
import { OptionRow, SubmenuScreenContent } from './styles';

const textSizeOptions = [
  SubtitleTextSizes.Smallest,
  SubtitleTextSizes.Small,
  SubtitleTextSizes.Normal,
  SubtitleTextSizes.Large,
  SubtitleTextSizes.Largest,
];

export const FontSizeScreen = () => {
  const locale = useLocale();
  const actions = useStoreActions((actions) => actions);
  const subtitleTextSize = useStoreState((state) => state.subtitles.subtitleTextSize);

  function handleSizeClick(size: SubtitleTextSizes) {
    actions.subtitles.setSubtitleTextSize(size);
    actions.settings.setSubtitleTextSize(size);
  }

  return (
    <SubmenuScreenContent>
      <MenuHeader
        title={locale.translations.SubtitleOptions.FontSize}
        onBack={() => actions.languageMenu.navigateBack()}
      />
      {textSizeOptions.map((textSizeOption) => (
        <OptionRow
          key={textSizeOption}
          active={subtitleTextSize === textSizeOption}
          onClick={() => handleSizeClick(textSizeOption)}
        >
          {locale.translations.SubtitleOptions.TextSizeOption(textSizeOption)}
        </OptionRow>
      ))}
    </SubmenuScreenContent>
  );
};
